import StatusBadge from "../../../../components/StatusBadge";
import { SeferSonucTipi, SeferUyeSatiri } from "../../../../helpers/seferFiyat";

interface Props {
    satirlar: SeferUyeSatiri[]
    /** Fiyat Bul penceresi: penceredeki tablo kalibi (fiyat-bul-tablo), Sefer kolonu yok (tek sefer). */
    pencere?: boolean
}

const ROZET: Record<SeferSonucTipi, string> = {
    yazilacak: 'badge-light-success',
    atlandi: 'badge-light-warning',
    bulunamadi: 'badge-light-danger'
};

/**
 * Sefer Fiyat Bul: seferden eklenen (ve atlanan) siparislerin sonucu. Bilgi amacli; secim yok,
 * seferden eklenenleri sunucu Kaydet'te otomatik yazar.
 */
const SeferUyeleri = ({ satirlar, pencere }: Props) => {
    const sayi = pencere ? 'fiyat-bul-sayi' : 'custom-text-right';

    return (
        <div className='table-responsive'>
            <table id={pencere ? undefined : 'kt_table_users'} className={'table align-middle dataTable no-footer ' + (pencere ? 'fiyat-bul-tablo' : 'table-row-dashed')}>
                <thead>
                    <tr className={'text-start fw-bolder text-uppercase' + (pencere ? '' : ' text-muted')}>
                        {!pencere && <th>Sefer</th>}
                        <th style={{ width: 1 }}>Sıra</th>
                        <th>Ref No</th>
                        <th>Ek Lokasyon</th>
                        <th>Hizmet Kalemi</th>
                        <th className={sayi}>Toplam Tutar</th>
                        <th className={sayi}>Brüt Tutar</th>
                        <th>Sonuç</th>
                    </tr>
                </thead>
                <tbody className='text-gray-600 fw-bold'>
                    {
                        satirlar.map(item =>
                            <tr key={item.anahtar}>
                                {!pencere && <td>{item.seferRefNo}</td>}
                                <td className={sayi}>{item.sira}</td>
                                <td>{item.refNo}</td>
                                <td><StatusBadge text={item.ekLokasyon} /></td>
                                <td>
                                    {item.hizmet}
                                    {
                                        // Toplama - Dagitim KM zinciri: "{km} km × {birim} TRY/km · ..." aciklamasi.
                                        item.kmAciklama && (
                                            <div className='text-muted fw-normal' style={{ fontSize: 12 }}>{item.kmAciklama}</div>
                                        )
                                    }
                                </td>
                                <td className={sayi}>{item.toplam}</td>
                                <td className={sayi}>{item.brut}</td>
                                <td><span className={'badge ' + ROZET[item.sonucTipi]}>{item.sonuc}</span></td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SeferUyeleri;
